import { Box } from "rebass/styled-components";
import Image from "next/image";
import Avatar from "boring-avatars";
import theme from "../../lib/theme";
import { useState, useEffect } from "react";

interface Props {
  size: number;
  name: string;
  alt: string;
  src: string;
  shouldPrioritizeImage: boolean;
}
const LiveAvatar = (props: Props) => {
  const { colors } = theme;
  const [loadAvatar, setLoadAvatar] = useState(undefined);

  useEffect(() => {
    setLoadAvatar(props.src.includes("fallback") ? true : false);
  }, [props.src]);

  return (
    <Box
      width={props.size}
      height={props.size}
      css={{
        position: "relative",
        ".image": {
          borderRadius: "50%"
        }
      }}
    >
      {loadAvatar !== undefined &&
        (loadAvatar ? (
          <Avatar
            size={props.size}
            variant="beam"
            name={props.name}
            colors={[colors.lightGray, colors.gray]}
          />
        ) : (
          <Image
            src={props.src}
            alt={props.alt}
            className="image"
            priority={props.shouldPrioritizeImage}
            fill
            sizes="100vw" />
        ))}
    </Box>
  );
};

LiveAvatar.defaultProps = {
  shouldPrioritizeImage: true
};

export default LiveAvatar;
